<template>
  <div
    class="watchlist_item text-prediction"
    v-if="watchlist.watchlistType == 'text-prediction'"
  >
    <div class="remove c-pointer" v-if="isCreateView">
      <i class="fas fa-minus-circle" @click="removeItem(index)"></i>
    </div>
    <SparklineComponent
      v-if="chartData && gainValue"
      :data="chartData"
      :isPositive="gainValue >= 0"
    />
    <div class="top_card_stock_detail stock-symbol">
      <StockImageTag
        @click.stop="goToStockDetail(watchlist.symbol, watchlist.market)"
        :stockData="watchlist"
        :toFixed="true"
        :imgUrl="watchlist.image ?? watchlist.logoUrl"
        :symbol="watchlist.symbol"
        :market="watchlist.market"
      />
      <p @click.stop="goToStockDetail(watchlist.symbol, watchlist.market)">
        {{ watchlist.symbol }}
        <span title="watchlist.name" class="no-rtl">{{
          watchlist.name ?? watchlist.companyName
        }}</span>
      </p>
      <p class="price right">
        <span class="heading">Current</span>
        <span class="d-flex text-white" v-html="$filters.systemNumberConventionOld(watchlist.price, true)" />
        <span>{{ currentDate }}</span>
      </p>
    </div>
    <div class="top_card_stock_detail">
      <p class="price">
        <span class="heading">Prediction</span>
        <span class="d-flex text-white" v-html="$filters.systemNumberConventionOld(watchlist.predictedPrice, true)" />
        <span>{{ predictionDate }}</span>
      </p>

      <div class="change" v-if="gainValue" title="gainValue">
        {{ Math.abs(gainValue) }}%
        <div
          class="change_chip"
          :class="{ bearish: gainValue >= 0 }"
          :innerText="gainValue < 0 ? 'Bearish' : 'Bullish'"
        ></div>
      </div>
    </div>
  </div>
  <div
    class="watchlist_item watchlist_grid_item"
    v-else-if="watchlist.watchlistType == 'watchlist-prediction'"
  >
    <div class="remove c-pointer" v-if="isCreateView">
      <i class="fas fa-minus-circle" @click="removeItem(index)"></i>
    </div>
    <div class="top_card_stock_detail expanded stock-symbol">
      <StockImageTag
        @click.stop="goToStockDetail(watchlist.symbol, watchlist.market)"
        :stockData="watchlist"
        :toFixed="true"
        :imgUrl="watchlist.image ?? watchlist.logoUrl"
        :symbol="watchlist.symbol"
        :market="watchlist.market"
      />
      <p @click.stop="goToStockDetail(watchlist.symbol, watchlist.market)">
        {{ watchlist.symbol }}
        <span title="watchlist.name" class="no-rtl">{{
          watchlist.name ?? watchlist.companyName
        }}</span>
      </p>
    </div>
    <p class="price">
      <span class=" d-flex text-white" v-html="$filters.systemNumberConventionOld(watchlist.price, true)" />
      <span>{{ currentDate }}</span>
    </p>
    <p class="price">
      <span class=" d-flex text-white" v-html="$filters.systemNumberConventionOld(watchlist.predictedPrice, true)" />
      <span>{{ predictionDate }}</span>
    </p>
    <div class="change" title="gainValue" v-if="gainValue">
      {{ Math.abs(gainValue) }}%
      <div
        class="change_chip"
        :class="{ bearish: gainValue >= 0 }"
        :innerText="gainValue < 0 ? 'Bearish' : 'Bullish'"
      ></div>
    </div>
  </div>
  <!-- Normal Watchlist -->
  <div class="watchlist_item" v-else>
    <div class="top_card_stock_detail stock-symbol">
      <StockImageTag
        @click.stop="goToStockDetail(watchlist.symbol, watchlist.market)"
        :stockData="stockData"
        :toFixed="true"
        :imgUrl="watchlist.image ?? watchlist.logoUrl"
        :symbol="watchlist.symbol"
        :market="watchlist.market"
        :stockId="watchlist.stock_id"
      />
      <p @click.stop="goToStockDetail(watchlist.symbol, watchlist.market)">
        {{ watchlist.symbol }}
        <span title="watchlist.name" class="no-rtl">{{
          watchlist.name ?? watchlist.companyName
        }}</span>
      </p>

      <span v-if="stockData" title="stockData.price" class="stockId">
        <p class="priceTagDv text-white">
          <span v-html="$filters.systemNumberConvention(watchlist.price, true)" />
        </p>
        <span
          class="price__tag"
          title="stockData.changesPercentage"
          :class="
            stockData.changesPercentage >= 0 ||
            stockData.changesPercentage == 'n/a'
              ? 'positive'
              : 'negative'
          "
        >
          <i
            class="fas"
            :class="
              stockData.changesPercentage >= 0 ||
              stockData.changesPercentage == 'n/a'
                ? 'fa-caret-up'
                : 'fa-caret-down'
            "
          ></i>
          {{
            Math.abs(
              $filters.systemNumberConvention(stockData.changesPercentage)
            )
          }}%
        </span>
      </span>

      <!-- <span title="stockData.price" class="stockId" v-if="stockData">
        {{ $filters.systemNumberConvention(stockData.price, true) }}
        <span
          class="price__tag"
          :class="stockData.changesPercentage >= 0 ? 'positive' : 'negative'"
        >
          <i
            class="fas"
            :class="
              stockData.changesPercentage >= 0 ? 'fa-caret-up' : 'fa-caret-down'
            "
          ></i>
          {{
            $filters.systemNumberConvention(
              stockData.changesPercentage,
              false,
              true
            )
          }}%
        </span>
      </span> -->
      <div class="remove c-pointer" v-if="isCreateView">
        <i class="fas fa-minus-circle" @click="removeItem(index)"></i>
      </div>
    </div>
    <div
      class="description"
      v-if="watchlist.description != null && watchlist.description != ''"
    >
      <p
        ref="desElement"
        class="description_text"
        :innerHTML="watchlist.description"
        @click.stop="checkTextLength()"
      ></p>
      <a
        v-if="isTruncated"
        class="anchor_tag--more"
        @click.stop="checkTextLength(false)"
        >See More</a
      >
    </div>
  </div>
</template>

<script lang="ts">
import IconComponent from "@/components/IconComponent.vue";
import { StockMarkets } from "../../../models/stocks.model";
import utilService from "@/services/util.service";
import { computed, defineComponent, nextTick, onMounted, ref, watch } from "vue";
// import useHeaders from "../../../composables/components/headers.composable";
import useHeaders from "@/composables/headers.composable";
import WatchList from "../../../models/watchList.modal";
import SparklineComponent from "@/components/SparklineComponent.vue";
import filters from "@/helpers/filters";
import PostsModel from "../../../models/posts.model";
import { useSocketStockData } from "@/composables/stock_data.composable";
import { watchOnce } from "@vueuse/core";
import { useStockSocket } from "@/composables/stock_socket.composable";

export default defineComponent({
  props: {
    post: PostsModel,
    watchlist: WatchList,
    index: Number,
    stocks: Array,
    isCreateView: Boolean,
  },
  // props: ["watchlist", "index", "stocks", "isCreateView"],
  components: { IconComponent, SparklineComponent },
  setup(props, context) {
    const gainValue = ref();
    const { showSearchBar } = useHeaders(props);
    const isTruncated = ref<boolean>(false);
    const desElement = ref<any>();
    const currentDate = computed(() => {
      var date = +new Date();
      if (props.post && props.post.createdOn) {
        date = +new Date(props.post.createdOn)
      }
      return filters.formatDate(date);
    });
    const chartData = computed(() => {
      if (props.watchlist && props.watchlist.historicalData) {
        return JSON.parse(props.watchlist.historicalData);
      }
      return null;
    });
    const predictionDate = computed(() =>
      {
        const date = +new Date(props.watchlist!.predictionDate)
        return filters.formatDate(date)
      }
    );
    const getImageUrl = (url: string, directory: string | null) =>
      utilService.getImageUrl(url, directory);
    const removeItem = (index: number = -1) => {
      if (props.stocks! && index != -1) {
        props.stocks!.splice(index, 1);
      }
    };
    const goToStockDetail = (symbol: string, type: string) => {
      showSearchBar.value = false;
      utilService.goToStockScreen(symbol, type);
      hideModal();
    };

    onMounted(() => {
      checkTextLength();
      if (props.watchlist?.price! < props.watchlist?.predictedPrice!) {
        gainValue.value = filters.systemNumberConvention(
          100 -
            (props.watchlist!.price! / props.watchlist!.predictedPrice!) * 100,
          false,
          true
        );
      } else {
        var perc = props.watchlist?.predictedPrice! / props.watchlist?.price!;
        gainValue.value = -filters.systemNumberConvention(
          (1 - perc) * 100,
          false,
          true
        );
      }
    });

    const checkTextLength = (toTruncate: boolean = true) =>
      utilService.clampText(desElement.value, isTruncated, toTruncate);

    const getStockImage = (stockId: string, type: StockMarkets) =>
      utilService.getStockImage(stockId, type);

    const hideModal = () => {
      context.emit("closeModal");
    };

    // const { stockData } = useSocketStockData(
    //   WatchList.getGeneralObjectForStockData(props.watchlist)
    // );

    const { addStockId, checkStockExistence } = useStockSocket();

    const initialObject = () => {
      let obj = {
        _id: props.watchlist?._id,
        symbol: props.watchlist?.symbol,
        companyName: props.watchlist?.name,
        last: props.watchlist?.price,
        change: props.watchlist?.change,
        changePercent: props.watchlist?.changePercent,
        market: props.watchlist?.exchange ?? "",
      };
      if (!checkStockExistence(props.watchlist?._id)) {
        addStockId({ showTrendChart: true, stockId: props.watchlist?._id });
      }
      return obj;
    };

    const { stockData, updateStockInfoObject } = useSocketStockData(
      initialObject()
    );

    watch(
      () => props.watchlist,
      async (newStockData) => {
        updateStockInfoObject(initialObject());
        await nextTick(); // Ensure DOM updates immediately
      },
      { deep: true }
    );

    onMounted(() => {
      updateStockInfoObject(initialObject());
    });
    
    return {
      gainValue,
      stockData,
      chartData,
      currentDate,
      predictionDate,
      isTruncated,
      desElement,
      getImageUrl,
      goToStockDetail,
      removeItem,
      getStockImage,
      checkTextLength,
      hideModal,
    };
  },
});
</script>

<style lang="scss" scoped>
.description_text {
  margin: 10px 0 0;
}
.watchlist_item {
  padding: 15px;
  &:not(:last-child) {
    margin-bottom: 15px;
  }
  background: var(--base-light);
  border-radius: 12px;
  .description{
    border-top: 1px solid var(--color-dark-purple13);margin-top: 15px;padding-top: 15px;
    p{margin: 0;font-size: var(--font-xs);font-weight: 400;color: var(--text-color);line-height: 24px;word-break: break-word;
      
    &.truncate{@include clampLines();}
    }
  }
  .price {
    .text-white {
      color: var(--text-color) !important
    }
  }
  .change {
    text-align: left !important;
    .change_chip {
      margin-inline-start: 0 !important;
    }
  }
}
  .stock-symbol {
    display: flex;
    .stockId {
      text-align: right;
      padding-inline-end:  var(--tile-horizontal-gap);
      line-height: 1.2;
      > span {
        &:first-child {
          display: block;
          font-weight: 600
        }
      }
    }
      h6, p {
          font-size: var(--font-lg) !important;
          font-weight: 500 !important;
          line-height: 1.2 !important;
          padding-inline-start: var(--tile-horizontal-gap) !important;
          margin: 0 !important;
          color: var(--white-color) !important;
          span {
            display: block !important;
            font-weight: 400 !important;
            font-size: var(--font-sm) !important;
            color: var(--grey-color) !important
          }
        }
        p {
          line-height: 1.3 !important;
        }
    }
    .remove {
      color: var(--recommend-bearish);
      margin-top: 6px
    }
</style>